import {
    Flex,
    NumberDecrementStepper,
    NumberIncrementStepper,
    NumberInput,
    NumberInputField,
    NumberInputStepper,
    Select,
} from '@chakra-ui/react';

export interface WidgetDateFilterValue {
    operator?: string;
    unit?: string;
    amount?: number;
}

export const WidgetDateFilter = ({
    filterValue,
    setFilterValue,
}: {
    filterValue: WidgetDateFilterValue;
    setFilterValue: (filterValue: WidgetDateFilterValue) => void;
}) => {
    return (
        <Flex gap={1} alignItems="center">
            <Select
                size="sm"
                minWidth="100px"
                value={filterValue?.operator}
                onChange={(ev) => {
                    const operator = ev.target.value;
                    setFilterValue({
                        operator,
                        ...((operator === 'next' || operator === 'last') && {
                            amount: 1,
                            unit: 'days',
                        }),
                    });
                }}
            >
                <option></option>
                <option value="next">next</option>
                <option value="last">last</option>
                <option value="week">this week</option>
                <option value="month">this month</option>
                <option value="quarter">this quarter</option>
                <option value="year">this year</option>
            </Select>
            {(filterValue?.operator === 'next' || filterValue?.operator === 'last') && (
                <>
                    <NumberInput
                        size="sm"
                        precision={0}
                        step={1}
                        minWidth="80px"
                        min={1}
                        value={filterValue?.amount}
                        onChange={(str, amount) => {
                            setFilterValue({
                                ...filterValue,
                                amount,
                            });
                        }}
                    >
                        <NumberInputField />
                        <NumberInputStepper>
                            <NumberIncrementStepper />
                            <NumberDecrementStepper />
                        </NumberInputStepper>
                    </NumberInput>
                    <Select
                        size="sm"
                        minWidth="120px"
                        value={filterValue?.unit}
                        onChange={(ev) => {
                            setFilterValue({
                                ...filterValue,
                                unit: ev.target.value,
                            });
                        }}
                    >
                        <option></option>
                        <option value="days">days</option>
                        <option value="weeks">weeks</option>
                        <option value="months">months</option>
                    </Select>
                </>
            )}
        </Flex>
    );
};
